/**
 * 素材媒体类型判定：按素材地址（OSS URL）末段扩展名区分图片与视频。
 * 载入页/开始页背景允许图片或视频，设置页预览与播放层据此选择 img / video 渲染与播放。
 */
/** 视频素材扩展名白名单，与素材弹窗上传口径一致（含后端支持但上传入口未开放的 m4v/avi）。 */
export const VIDEO_ASSET_EXTENSIONS = ['mp4', 'webm', 'mov', 'm4v', 'avi'];
/**
 * 从素材 URL 中解析文件名（最后一段路径）；非 http(s) 地址返回 undefined。
 * OSS 上不保存原始文件名，上传时以「素材ID.扩展名」落桶，
 * 因此 URL 末段即带扩展名的文件名，可用于字段回显与素材类型判定。
 * @param assetId 素材 ID（仅接受 http/https URL）。
 */
export function resolveAssetBasename(assetId) {
    if (!/^https?:\/\//.test(assetId)) {
        return undefined;
    }
    try {
        const basename = decodeURIComponent(new URL(assetId).pathname.split('/').pop() ?? '');
        return basename || undefined;
    }
    catch {
        return undefined;
    }
}
/**
 * 判断素材地址是否为视频素材（按 URL 末段扩展名判定）。
 * @param assetId 素材 ID。
 */
export function isVideoAssetId(assetId) {
    const basename = resolveAssetBasename(assetId) ?? assetId;
    const extension = basename.split('.').pop()?.toLowerCase() ?? '';
    return VIDEO_ASSET_EXTENSIONS.includes(extension);
}
